// frontend/OtoScopDataUi.jsx
import React, { useEffect, useMemo } from "react";
import { Box, Typography, CardMedia, Grid, Button } from "@mui/material";
import QRCode from "react-qr-code";
import leftear from "../../assets/images/left-ear.png";
import rightear from "../../assets/images/right-ear.png";

const OtoScopDataUi = ({ params, fetchFunction }) => {
  return (
    <Box sx={{ p: 2, mt: 4, width: "100%", height: "100%" }}>
      <Grid container spacing={3}>
        {" "}
        {/* spacing added here */}
        {/* Left Ear */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              border: "2px solid #1B4381",
              borderRadius: "40px",
              height: 450,
              width: "100%", // make it responsive
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {params?.left_ear ? (
              <CardMedia
                component="img"
                height="400"
                image={params.left_ear}
                alt="Left Ear"
              />
            ) : (
              <CardMedia
                component="img"
                height="400"
                image={leftear}
                alt="Left Ear"
              />
            )}
          </Box>
        </Grid>
        {/* QR and Instructions */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              height: 450,
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              //   textAlign: "center",
              //   border: "2px solid #1B4381",
              //   borderRadius: "40px",
              width: "100%", // responsive
            }}
          >
            <Box sx={{ p: 2 }}>
              <QRCode
                size={110}
                style={{ height: "auto", maxWidth: "100%" }}
                value={params?.id || "No Patient ID"}
              />
            </Box>
            <Typography variant="h6" sx={{ mt: 2 }}>
              Open the app, scan the QR, and capture pictures of both ears.
            </Typography>

            <Button
              variant="outlined"
              onClick={() => {
                fetchFunction(params?.id);
              }}
              sx={{ mt: 2 }}
            >
              <Typography variant="h5">Load Images</Typography>
            </Button>
          </Box>
        </Grid>
        {/* Right Ear */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              border: "2px solid #1B4381",
              borderRadius: "40px",
              height: 450,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {params?.right_ear ? (
              <CardMedia
                component="img"
                height="400"
                image={params.right_ear}
                alt="Right Ear"
              />
            ) : (
              <CardMedia
                component="img"
                height="400"
                image={rightear}
                alt="Right Ear"
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OtoScopDataUi;
